<template lang="pug">
.campos-filtros
    el-input.campo.campo--busca.input-busca(
        v-model='searchModel',
        :placeholder='searchPlaceholder',
        prefix-icon='el-icon-search',
        clearable,
        @keyup.enter.native='emitBuscar',
        @clear='emitBuscar'
    )

    el-select.campo.campo--sucursal(
        v-model='sucursalModel',
        v-loading='carregandoSucursais',
        :placeholder='$t("mensagens.sucursales.placeholderSucursal")',
        clearable,
        filterable,
        @change='emitBuscar'
    )
            el-option(
                v-for='item in sucursais',
                :key='item.id',
                :label='item.label',
                :value='item.id'
            )

    el-button.btn-limpar(
        v-if='exibeLimpar',
        type='secondary',
        @click='emitLimpar'
    )
        i.mdi.mdi-delete-circle-outline.mr-1
        | {{ $t('mensagens.comuns.limpar') }}
</template>

<script>
export default {
    name: 'FiltrosSucursales',
    props: {
        search: {
            type: String,
            default: ''
        },
        sucursal: {
            type: [String, Number],
            default: ''
        },
        sucursais: {
            type: Array,
            default: () => []
        },
        searchPlaceholder: {
            type: String,
            default: ''
        },
        carregandoSucursais: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        searchModel: {
            get() {
                return this.search;
            },
            set(value) {
                this.$emit('update:search', value);
            }
        },
        sucursalModel: {
            get() {
                return this.sucursal;
            },
            set(value) {
                this.$emit('update:sucursal', value);
            }
        },
        exibeLimpar() {
            return Boolean(this.search || this.sucursal);
        }
    },
    methods: {
        emitBuscar() {
            this.$emit('buscar');
        },
        emitLimpar() {
            this.$emit('limpar');
        }
    }
};
</script>

<style lang="scss" scoped>
.campos-filtros {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 2rem;
    margin-bottom: 2rem;

    .campo--busca {
        width: 550px;
    }

    .campo--sucursal {
        width: 280px;
    }

    .input-busca {
        ::v-deep .el-input__inner {
            height: 40px;
            line-height: 40px;
        }
    }

    .btn-limpar {
        height: 40px;
        background-color: #f4f4f5;
        border: 0.5px solid var(--gray);
        border-radius: 5px;

        span {
            margin-left: 5px;
            color: #183b57 !important;
        }
        i {
            color: #183b57 !important;
        }
    }
}
</style>
